var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronsRightSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.569,
    height: 16.572,
    viewBox: "0 0 16.569 16.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevrons-right-solid-2",
    d: "M32.272,41.047a1.185,1.185,0,0,1,0-1.675l7.1-7.1a1.185,1.185,0,1,1,1.675,1.675l-6.264,6.264,6.261,6.264a1.185,1.185,0,0,1-1.675,1.675l-7.1-7.1Zm14.2,7.1-7.1-7.1a1.185,1.185,0,0,1,0-1.675l7.1-7.1a1.185,1.185,0,1,1,1.675,1.675l-6.264,6.264,6.261,6.264a1.185,1.185,0,0,1-1.675,1.675Z",
    transform: "translate(-31.925 -31.925)",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsRightSolid);
export default __webpack_public_path__ + "static/media/chevrons-right-solid.d83254e18a501904c29c1a315a41d1b5.svg";
export { ForwardRef as ReactComponent };